import {Button} from "@mui/material";
import {fni18n} from "../../services/commonService";

//MUI
import {Alert,Box,Checkbox,Container,Divider,FormControl,FormControlLabel,Grid,InputLabel,MenuItem,Paper,Select,Stack,TextField,Typography} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DownloadForOfflineSharpIcon from "@mui/icons-material/DownloadForOfflineSharp";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
function setIcon(icon){

  if(icon==='Search'){
   return( <SearchIcon/>);
  }
  else if(icon==='Down'){
   return(<DownloadIcon/>);
  }
  else if(icon==='Save'){
    return(<SaveIcon/>);
   }
   else if(icon==='Cancel'){
    return(<RefreshIcon/>);
   }
   else if(icon==='Delete'){
    return(<DeleteIcon/>);
   }
   else if(icon==='Refresh'){
    return(<RefreshIcon/>);
   }
   else if(icon==='Close'){
    return(<CloseIcon/>);
   }
   else if(icon==='Modify'){
    return(<EditIcon />);
   }
   else if(icon==='Create'){
    return(<AddCircleOutlineIcon />);
   }
   else if (icon === 'Add') {
    return (<AddIcon/>);
   }
  return(<></>);
};

const UButton = (props) => {
  const variant = props.variant;
  const icon = props.icon;
  const text = props.children;
  const  isTab = props.isTab?true:false;
  const sx = props.sx;
  const color = props.color?props.color:'primary';

  return(
    <FormControl sx={{ width: 'auto' }}>      
      <Stack direction="row">
        <Button variant={ variant || "contained" }  color={color} sx={isTab?{'ml':'15px', boxShadow: 'none',textTransform: "none",}:{ boxShadow: 'none',textTransform: "none",}} onClick={()=>{props.onButtonClick(text)}}>
        {setIcon(icon)}
        {fni18n(props.children)}</Button>
      </Stack>
    </FormControl>
    
  );
};
export default UButton;